import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ButtonItem } from "../../../../../entities/UIEntities/ButtonItem";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import {
  ADD_PARKER_FORM_STEPS,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { phoneNumberToSend } from "../../../../../utils/CommonUtils";
import {
  getErrorMessage,
  isEmail,
  isPhoneNumber,
  isRequired,
} from "../../../../../utils/FormUtils";
import UserTypesButtons from "../../../Buttons/CustomToggleButton/UserTypesButtons/UserTypesButtons";
import PhoneInputWithoutVerification from "../../../Inputs/CustomInputs/PhoneInputWithoutVerification";
//import SitesSelectInput from "../../../Inputs/CustomInputs/SitesSelectInput";
import ScopesSelectInput from "../../../Inputs/CustomInputs/ScopesSelectInput";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import classes from "../WizardForm.module.css";

const InviteNewGmtUserStep = (props) => {
  const userRoles = useSelector((state) => state.user.initialState.roles);
  const [errors, setErrors] = useState({});
  const [stepHeader, setStepHeader] = useState(new StepHeaderEntity(
    Strings.STEPS_TITLES.INVITE_NEW_GMT_MODAL_TITLE,
    Strings.STEPS_TITLES.INVITE_NEW_GMT_MODAL_SUB_TITLE,
    Icons.NEW_PARKER,
    null
  ));

  useEffect(() => {
    if (props.currentStep === ADD_PARKER_FORM_STEPS.INVITE_NEW_GMT) {
      const hasError = Object.values(errors).some((hasError) => hasError);
      props.handleCurrentStepValidity(hasError);
    }
  }, [errors]);
  
  useEffect(() => {
    store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
  }, [stepHeader]);

  useEffect(() => {
    validateStep();
  }, [props.site, props.role, props.currentStep]);

  const validateStep = () => {
    setErrors({
      ...errors,
      email: !isRequired(props.email).isValid || !isEmail(props.email).isValid,
      phoneNumber: !isRequired(props.phoneNumber).isValid || !isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)).isValid,
      userTypeValue: !isRequired(props.role).isValid,
      siteValue: !isRequired(props.site).isValid
    });
  };

  const handleRoleChange = (event, role) => {
    const eventValue = { [INPUTS_PROPS.ROLE]: role };
    props.handleChange(eventValue);
  };

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  if (props.currentStep !== ADD_PARKER_FORM_STEPS.INVITE_NEW_GMT) {
    return null;
  }

  return (
    <div className={classes.stepContainer}>
      <TextInput
        label={Strings.INPUT_LABELS.EMAIL}
        id={INPUTS_PROPS.EMAIL}
        value={props.email}
        isStepSubmitted={props.isStepSubmitted}
        handleError={handleError} // added
        onChange={props.handleChange}
        hasError={!isRequired(props.email).isValid || !isEmail(props.email).isValid}
        errorMessage={getErrorMessage(isRequired(props.email)) ? getErrorMessage(isRequired(props.email)) : getErrorMessage(isEmail(props.email))}
      />

      <PhoneInputWithoutVerification
        label={Strings.INPUT_LABELS.PHONE_NUMBER}
        id={INPUTS_PROPS.PHONE_NUMBER}
        phoneVerifiedId={INPUTS_PROPS.PHONE_VERIFIED}
        value={props.phoneNumber}
        isVerifyValidationNeeded={false}
        dialingCode={props.dialingCode}
        isPhoneVerified={props.isPhoneVerified}
        onChange={props.handleChange}
        handleError={handleError} // added
        isStepSubmitted={props.isStepSubmitted}
        hasError={!isRequired(props.phoneNumber).isValid || !isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)).isValid}
        errorMessage={getErrorMessage(isRequired(props.phoneNumber)) ? getErrorMessage(isRequired(props.phoneNumber)) : getErrorMessage(isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)))}
      />
      <div className={classes.assignScopesContainer}>
        <div className={classes.stepTitle}>
          {Strings.STEPS_TITLES.ASSIGN_TITLE}
        </div>
        <div className={classes.stepSubTitle}>
          {Strings.STEPS_TITLES.ASSIGN_SUB_TITLE}
        </div>

        <ScopesSelectInput
          label={Strings.INPUT_LABELS.FACILITY}
          id={INPUTS_PROPS.SITE}
          onChange={props.handleChange}
          list={props.scopesList} // list={props.sitesList}
          sitesData={props.sitesData} // added
          value={props.scopesList?.length > 0 ? props.scopesList[0].id : 0} // value={props.sitesList?.length > 0 ? props.sitesList[0].id : 0}
            // handleError={handleError}
          //   hasError={!isEmail(props.email).isValid}
          //   errorMessage={getErrorMessage(isEmail(props.email))}
        />

        <div className={classes.rolesContainer}>
          <UserTypesButtons
            buttonsList={userRoles
              // .filter((userType) => userType.siteId === siteValue)
              .map((role) => new ButtonItem(role.id, role.name))}
            selectedValue={props.role}
            id={INPUTS_PROPS.ROLE}
            handleChange={handleRoleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default InviteNewGmtUserStep;
